/* header-search.js : recherche prédictive de l'en-tête (Codex des Dragons).
   Index du catalogue chargé une fois par session (/collections/all?view=hsearch,
   template collection.hsearch.liquid), recherche faite dans le navigateur :
   instantanée, sans accents, chaque mot tapé doit commencer un mot du nom, du type ou des tags.
   Les titres produits sont raccourcis à leur partie avant « - » (le type est affiché dessous). */
(function () {
  const root = document.querySelector('[data-hsearch]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  // Le composant est rendu en fin de page : on le met à la place de la loupe de l'en-tête.
  const legacy = document.querySelector('.header__actions a.header__icon[href*="/search"]');
  if (!legacy) return;
  legacy.replaceWith(root);
  root.hidden = false;

  const input = root.querySelector('[data-hsearch-input]');
  const form = root.querySelector('[data-hsearch-form]');
  const panel = root.querySelector('[data-hsearch-panel]');
  const idle = root.querySelector('[data-hsearch-idle]');
  const results = root.querySelector('[data-hsearch-results]');
  const openBtn = root.querySelector('[data-hsearch-open]');
  const closeBtn = root.querySelector('[data-hsearch-close]');
  const scrim = document.querySelector('[data-hsearch-scrim]');
  if (scrim) document.body.appendChild(scrim); // hors de l'en-tête flouté, sinon le voile reste coincé dedans
  const cats = Array.from(root.querySelectorAll('[data-hsearch-cat]'));
  const collapsed = window.matchMedia('(max-width: 1179px)');
  const root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  if (!collapsed.matches) input.placeholder = 'Chercher une création'; // champ étroit dans la barre

  let timer = null, lastQuery = '', activeType = '', lastProducts = [];

  const ACCENTS = [
    [/sous-classe|^classe/i, 'sousclasse'], [/codex|objet/i, 'codex'], [/one-shot|aventure/i, 'oneshot'],
    [/bestiaire|monstre/i, 'bestiaire'], [/index|table/i, 'annexe'], [/aide/i, 'aides'],
    [/bundle/i, 'bundle'], [/abonnement|pass/i, 'abonnement'], [/cairn/i, 'cairn']
  ];
  const accentOf = (t) => { for (const [re, k] of ACCENTS) if (re.test(t || '')) return `var(--prod-${k})`; return 'var(--color-accent)'; };
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  const money = (v) => { const n = parseFloat(v); if (!n) return ''; return fmt.format(n).replace(/[,.]00(?=\s|$)/, ''); };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const highlight = (text, q) => {
    const t = String(text || ''); const nt = norm(t); const words = norm(q).split(/\s+/).filter((w) => w.length > 1);
    let out = esc(t);
    for (const w of words) {
      const i = nt.indexOf(w);
      if (i > -1) { const seg = t.slice(i, i + w.length); out = out.replace(esc(seg), `<mark>${esc(seg)}</mark>`); }
    }
    return out;
  };

  function open() {
    root.classList.add('is-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    showPanel();
    if (collapsed.matches) setTimeout(() => input.focus(), 20);
  }
  function showPanel() {
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    render(input.value.trim());
  }
  function close() {
    root.classList.remove('is-open');
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    setActive(null);
  }

  function render(q) {
    if (q.length < 2) {
      idle.hidden = false; results.innerHTML = '';
      cats.forEach((a) => a.parentElement.hidden = false);
      return;
    }
    clearTimeout(timer);
    timer = setTimeout(() => fetchResults(q), 60);
  }

  // Index du catalogue (une requête par session)
  let index = null, indexPromise = null;
  const SKIP_TAGS = /^(dnd 2024|dnd 5e|homebrew francais)$/;
  function prep(list) {
    return list.map((p) => {
      const title = norm(p.t), type = norm(p.y);
      const tags = String(p.g || '').split('|').map(norm).filter((t) => t && !SKIP_TAGS.test(t));
      const words = (s) => s.split(/[^a-z0-9]+/).filter(Boolean);
      return { title: p.t, url: p.u, type: p.y, price: (p.p || 0) / 100, image: p.i, available: p.a,
        wTitle: words(title), wType: words(type), wTags: tags.flatMap(words), nTitle: title };
    });
  }
  function loadIndex() {
    if (index) return Promise.resolve(index);
    if (indexPromise) return indexPromise;
    try { const c = sessionStorage.getItem('hsearch-index-v1'); if (c) { index = prep(JSON.parse(c)); return Promise.resolve(index); } } catch (e) {}
    indexPromise = fetch(`${root_url}collections/all?view=hsearch`)
      .then((r) => r.text())
      .then((t) => { const list = JSON.parse(t); try { sessionStorage.setItem('hsearch-index-v1', t); } catch (e) {} index = prep(list); return index; })
      .catch((e) => { indexPromise = null; throw e; });
    return indexPromise;
  }
  // Synonymes (refonte 2027) : anglais, abréviations, orthographes fréquentes. Chaque mot tapé
  // peut correspondre à n'importe laquelle de ses variantes.
  const SYN = {
    barbarian: ['barbare'], bard: ['barde'], cleric: ['clerc', 'pretre'], pretre: ['clerc'], druid: ['druide'],
    sorcerer: ['ensorceleur'], ensorceleuse: ['ensorceleur'], sorcier: ['ensorceleur', 'occultiste'], fighter: ['guerrier'], guerriere: ['guerrier'],
    wizard: ['magicien'], mage: ['magicien'], mago: ['magicien'], magicienne: ['magicien'], monk: ['moine'],
    warlock: ['occultiste'], paladine: ['paladin'], ranger: ['rodeur'], rodeuse: ['rodeur'], rogue: ['roublard'], voleur: ['roublard'], assassin: ['roublard'],
    subclass: ['sous'], souclasse: ['sous'], sousclasse: ['sous'],
    oneshot: ['one'], scenario: ['one', 'aventure'], aventure: ['one', 'aventure'], adventure: ['one'], campagne: ['one'],
    monstre: ['bestiaire', 'creature'], monstres: ['bestiaire', 'creature'], monster: ['bestiaire'], creature: ['bestiaire', 'creature'], creatures: ['bestiaire'],
    objet: ['objet', 'codex'], objets: ['objet', 'codex'], item: ['objet', 'codex'], items: ['objet', 'codex'], loot: ['objet', 'codex'], tresor: ['objet', 'codex'],
    arme: ['arme'], armes: ['arme'], potion: ['potion'], potions: ['potion'],
    pnj: ['pnj', 'generateur'], npc: ['pnj'], gratuit: ['gratuit', 'aide'], free: ['gratuit', 'aide'],
    table: ['table'], tables: ['table'], aleatoire: ['aleatoire', 'table'], random: ['aleatoire', 'table'],
    regle: ['index', 'regle'], regles: ['index', 'regle'], rules: ['index'], bundle: ['pack', 'bundle'], packs: ['pack', 'bundle'], pack: ['pack', 'bundle'],
    auberge: ['taverne'], tavern: ['taverne'], debutant: ['aide', 'personnages'], debuter: ['aide', 'personnages'],
  };
  const STOP = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'un', 'une', 'pour', 'd', 'l', 'en', 'a', 'et', 'avec', 'dnd', 'd&d', '2024', '5e']);
  const variants = (t) => [t].concat(SYN[t] || []).concat(t.length > 3 && t.endsWith('s') ? [t.slice(0, -1)] : []);

  function search(q) {
    let toks = norm(q).split(/[^a-z0-9]+/).filter(Boolean);
    const kept = toks.filter((t) => !STOP.has(t));
    if (kept.length) toks = kept;
    const wantPass = toks.some((t) => 'pass'.startsWith(t) || 'abonnement'.startsWith(t));
    const out = [];
    for (const p of index) {
      if (/abonnement/i.test(p.type || '') && !wantPass) continue;
      let score = 0, ok = true;
      for (const t of toks) {
        const vs = variants(t);
        const pre = (ws) => ws.some((w) => vs.some((v) => w.startsWith(v)));
        if (pre(p.wTitle)) score += 3;
        else if (pre(p.wType)) score += 2;
        else if (pre(p.wTags)) score += 1;
        else { ok = false; break; }
      }
      if (!ok) continue;
      if (p.nTitle.startsWith(toks[0])) score += 2;
      if (!p.available) score -= 5;
      out.push([score, p]);
    }
    return out.sort((a, b) => b[0] - a[0] || a[1].title.localeCompare(b[1].title, 'fr')).map((x) => x[1]);
  }

  // Moteur partagé avec la recherche de l'accueil (hero-search.js).
  window.CodexSearch = { loadIndex, search, accentOf, money, esc, highlight, shortType: (t) => String(t || '').replace(/^Sous-classe\s+/i, 'Sous-classe '), root: root_url };
  document.dispatchEvent(new Event('codexsearch:ready'));

  async function fetchResults(q) {
    lastQuery = q; activeType = '';
    idle.hidden = true;
    if (!index && !results.querySelector('.hsearch__items')) results.innerHTML = '<div class="hsearch__loading"></div>';
    try {
      await loadIndex();
      if (q !== input.value.trim()) return;
      draw(q, search(q), []);
    } catch (e) {
      results.innerHTML = '<p class="hsearch__empty">La recherche ne répond pas. Appuie sur Entrée pour la page de résultats.</p>';
    }
  }

  function draw(q, products, collections) {
    idle.hidden = true;
    lastProducts = products;
    const toks = norm(q).split(/[^a-z0-9]+/).filter(Boolean);
    const catMatch = (s) => { const ws = norm(s).split(/[^a-z0-9]+/).filter(Boolean); return toks.every((t) => ws.some((w) => w.startsWith(t))); };
    // Catégories : celles du menu qui correspondent + collections renvoyées par Shopify
    const seen = new Set();
    let catHtml = '';
    cats.forEach((a) => {
      if (catMatch(a.dataset.hsearchCat)) { seen.add(a.getAttribute('href')); catHtml += `<li>${a.outerHTML}</li>`; }
    });
    collections.slice(0, 4).forEach((c) => {
      if (seen.has(c.url) || /^(all|frontpage)$/.test(c.handle)) return;
      seen.add(c.url);
      catHtml += `<li><a class="hsearch__cat" href="${esc(c.url)}" style="--hs-accent: var(--color-accent);"><span class="hsearch__cat-dot" aria-hidden="true"></span><span class="hsearch__cat-name">${highlight(c.title, q)}</span></a></li>`;
    });

    let html = '';
    if (catHtml) html += `<div class="hsearch__group"><p class="hsearch__label">Catégories</p><ul class="hsearch__cats" role="list">${catHtml}</ul></div>`;
    html += `<div class="hsearch__group"><p class="hsearch__label">Créations${products.length ? ` (${products.length})` : ''}</p><div data-hsearch-filters></div><ul class="hsearch__items" role="listbox" data-hsearch-items></ul></div>`;
    html += `<a class="hsearch__all" href="${root_url}search?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last"><span>Tous les résultats pour « ${esc(q)} »</span><span aria-hidden="true">→</span></a>`;
    results.innerHTML = html;
    drawFilters(); drawItems(q);
  }

  function shortType(t) { return String(t || '').replace(/^Sous-classe\s+/i, 'Sous-classe '); }

  function drawFilters() {
    const box = results.querySelector('[data-hsearch-filters]');
    const counts = {};
    lastProducts.forEach((p) => { const k = p.type || 'Autre'; counts[k] = (counts[k] || 0) + 1; });
    const types = Object.keys(counts).sort((x, y) => counts[y] - counts[x] || x.localeCompare(y, 'fr'));
    if (types.length < 2) { box.innerHTML = ''; return; }
    box.className = 'hsearch__filters';
    box.innerHTML = `<button type="button" class="hsearch__filter" aria-pressed="${activeType === ''}" data-type="">Tout (${lastProducts.length})</button>` +
      types.map((t) => `<button type="button" class="hsearch__filter" aria-pressed="${activeType === t}" data-type="${esc(t)}">${esc(shortType(t))} (${counts[t]})</button>`).join('');
  }

  function drawItems(q) {
    const list = results.querySelector('[data-hsearch-items]');
    const items = lastProducts.filter((p) => !activeType || (p.type || 'Autre') === activeType).slice(0, 40);
    if (!items.length) {
      const sugg = [['Sous-classes', 'collections/sous-classes'], ['One-shots', 'collections/one-shots'], ['Objets magiques', 'collections/objets-magiques'], ['Tables aléatoires', 'collections/tables-aleatoires'], ['Gratuit', 'collections/aides-de-jeu']];
      list.outerHTML = `<div class="hsearch__empty"><p>Rien ne correspond à « ${esc(q)} » pour l'instant. Essaie une classe (Barbare, Magicien…), un type de création ou jette un œil ici :</p><p class="hsearch__sugg">${sugg.map(([l, u]) => `<a href="${root_url}${u}">${l}</a>`).join('')}</p></div>`;
      return;
    }
    list.innerHTML = items.map((p, i) => {
      const src = p.image || '';
      const price = p.price || 0;
      const priceHtml = price ? esc(money(price)) : 'Gratuit';
      return `<li role="presentation"><a class="hsearch__item" role="option" id="hs-opt-${i}" href="${esc(p.url)}" style="--hs-accent:${accentOf(p.type)}">
        ${src ? `<img class="hsearch__thumb" src="${esc(src)}" alt="" width="48" height="48" loading="lazy">` : '<span class="hsearch__thumb"></span>'}
        <span><span class="hsearch__name">${highlight(String(p.title || '').split(' - ')[0], q)}</span><span class="hsearch__type">${esc(shortType(p.type))}</span></span>
        <span class="hsearch__price${price ? '' : ' is-free'}">${priceHtml}</span></a></li>`;
    }).join('');
  }

  // Navigation clavier dans les liens du panneau
  function links() { return Array.from(panel.querySelectorAll('a')).filter((a) => a.offsetParent !== null); }
  function setActive(el) {
    panel.querySelectorAll('.is-active').forEach((a) => a.classList.remove('is-active'));
    if (el) { el.classList.add('is-active'); el.scrollIntoView({ block: 'nearest' }); input.setAttribute('aria-activedescendant', el.id || ''); }
    else input.removeAttribute('aria-activedescendant');
  }

  input.addEventListener('focus', () => { if (panel.hidden) showPanel(); loadIndex().catch(() => {}); });
  input.addEventListener('input', () => { if (panel.hidden) showPanel(); else render(input.value.trim()); });
  input.addEventListener('keydown', (e) => {
    const l = links(); const cur = panel.querySelector('a.is-active'); const i = l.indexOf(cur);
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(l[(i + 1) % l.length]); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(l[(i - 1 + l.length) % l.length]); }
    else if (e.key === 'Enter' && cur) { e.preventDefault(); window.location.href = cur.href; }
    else if (e.key === 'Escape') { close(); input.blur(); if (collapsed.matches && openBtn) openBtn.focus(); }
  });
  results.addEventListener('click', (e) => {
    const b = e.target.closest('.hsearch__filter');
    if (!b) return;
    e.stopPropagation(); activeType = b.dataset.type; drawFilters(); drawItems(lastQuery);
  });
  form.addEventListener('submit', (e) => { if (input.value.trim().length < 1) e.preventDefault(); });
  if (openBtn) openBtn.addEventListener('click', () => (root.classList.contains('is-open') ? close() : open()));
  // La croix vide le champ ; champ déjà vide (mobile) : elle ferme la barre.
  function syncValue() {
    const has = input.value.length > 0;
    root.classList.toggle('has-value', has);
    if (closeBtn) closeBtn.setAttribute('aria-label', has ? 'Effacer la recherche' : 'Fermer la recherche');
  }
  function clearSearch() {
    input.value = ''; lastQuery = ''; activeType = ''; lastProducts = [];
    syncValue(); setActive(null);
    if (panel.hidden) showPanel(); else render('');
    input.focus({ preventScroll: true });
  }
  if (closeBtn) closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (input.value) clearSearch(); else close();
  });
  input.addEventListener('input', syncValue);
  syncValue();
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('click', (e) => { if (!panel.hidden && !e.composedPath().includes(root) && e.target !== scrim) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) {
      e.preventDefault(); collapsed.matches ? open() : input.focus();
    }
  });
})();
